export enum BasicColumnTypes {
  Currency = 'currency',
  Date = 'date',
  Period = 'period',
  Year = 'year',
  YearInterval = 'yearInterval',
  DayInterval = 'dayInterval',
  Numeric = 'numeric',
  Percent = 'percentage',
  Text = 'text',
  Boolean = 'boolean'
}
